<template>
  <v-container
    class="grey lighten-5"
    style="max-width: 80%; margin-top: 15%; padding: 0; border-radius: 8px"
  >
    <v-row>
      <span class="font-weight-black" style="margin: auto"
        >แชร์เพื่อให้เพื่อนคุณมาเป็นเพื่อนกับเราเพื่อรับสิทธิประโยชน์มากมาย
        <v-btn
          :loading="loading3"
          :disabled="loading3"
          color="success"
          class="ma-2 white--text"
          @click="shareLine"
        >
          share
          <v-icon right dark> mdi-share-variant </v-icon>
        </v-btn></span
      >
    </v-row>
    <v-row>
      <span class="font-weight-black" style="margin: auto"
        >จำนวนครั้งการแชร์
      </span>
    </v-row>
    <v-row>
      <v-rating
        v-model="rating"
        :length="length"
        color="red lighten-3"
        background-color="grey lighten-1"
        readonly
        large
      ></v-rating>
      <div>
        <span class="text-caption text-uppercase">Share:</span>
        <span class="font-weight-bold">
          {{ rating }}
        </span>
      </div>
    </v-row>
    <v-row>
      <span class="font-weight-black" style="margin: auto"
        >รายชื่อเพื่อนที่ตอบรับคุณ
      </span>
    </v-row>
    <!-- <v-row> -->
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ชื่อเพื่อน</th>
            <th class="text-left">วันที่เข้าร่วม</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in desserts" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.date }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- </v-row> -->
    <!-- <v-row>
      <v-btn
        :loading="loading3"
        :disabled="loading3"
        color="success"
        class="ma-2 white--text"
        @click="shareLine"
      >
        share
        <v-icon right dark> mdi-share-variant </v-icon>
      </v-btn>
    </v-row> -->
  </v-container>
</template>

<script>
import image from "@/assets/Logo.png";
import * as browser from "@/ultils/browser";
import liffHelper from "@/ultils/helper/liftHelper";
import regisApi from "@/services/api/regis";
import * as moment from "moment";
// const moment = require('moment')
export default {
  data: () => ({
    image: image,
    data: null,
    loading3: false,
    line: "",
    length: 18,
    rating: 0,
    messages: [
        {
            "type": "flex",
            "altText": "คลิกและแชร์รับสิทธิประโยชน์มากมาย",
            "contents": {
                "body": {
                    "type": "box",
                    "layout": "vertical",
                    "contents": [
                        {
                            "url": "https://nextbest-store.s3-ap-southeast-1.amazonaws.com/campaign/1630595865783.png",
                            "size": "full",
                            "type": "image",
                            "action": {
                                "uri": "https://liff.line.me/1656090522-A50dBRDM?lineHostId=xxx",
                                "type": "uri",
                                "label": "action"
                            },
                            "gravity": "center",
                            "aspectMode": "cover",
                            "aspectRatio": "1:1"
                        }
                    ],
                    "paddingAll": "0px"
                },
                "size": "giga",
                "type": "bubble"
            }
        }
    ],
    headers: [
      {
        text: "ชื่อเพื่อน",
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: "วันที่เข้าร่วม",
        align: "start",
        sortable: false,
        value: "date",
      },
    ],
    desserts: [
      // {
      //   name: "Deedo",
      //   date: "02/09/21 21:08",
      // },
    ],
  }),
  async created() {
    this.line = this.$store.getters.getMember;
    // console.log("what", this.$route.query.lineHostId);
    if (this.$route.query.lineHostId) {
      let data = {
        lineId: this.$route.query.lineHostId,
        lineChainId: this.line.userId,
      };
      await regisApi.createRelation(data);
    }
    await this.fetchData();
    this.data = this.$store.getters.getData;
    try {
      await regisApi.saveLog(this.data);
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    async shareLine() {
      this.messages = JSON.stringify(this.messages);
      //   console.log(this.messages);
      this.messages = this.messages.replace("xxx", `${this.line.userId}`);
      this.messages = JSON.parse(this.messages);
      console.log(this.messages);
      let rs = await liffHelper.targetPicker(this.messages);
      console.log(rs)
      if (rs) {
        await regisApi.shareSuccess({ lineId: this.line.userId });
        await this.fetchData();
      }
      // console.log(rs);
    },
    async fetchData() {
      this.desserts = []
      let rsShare = await regisApi.getShareNum({ lineId: this.line.userId });
      if (rsShare) {
        this.rating = rsShare.num;
      }
      let rsFriend = await regisApi.getYourFriend({ lineId: this.line.userId });
      if (rsFriend.length > 0) {
        rsFriend.forEach((element) => {
          this.desserts.push({
            name: element.name,
            date: moment(element.date).format("DD/MM/YY HH:mm"),
          });
        });
      }
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
};
</script>
<style scoped>
.v-rating {
  /* max-width: 100%; */
  white-space: normal !important;
}
</style>